import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userCreate } from "../../store/auth/actions";
export var useCreateUser = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseUserCreate: (_a = state.Login.responseUserCreate) === null || _a === void 0 ? void 0 : _a.data,
            errorUserCreate: state.Login.errorUserCreate,
            loadingUserCreate: state.Login.loadingUserCreate,
        });
    }), responseUserCreate = _a.responseUserCreate, errorUserCreate = _a.errorUserCreate, loadingUserCreate = _a.loadingUserCreate;
    useEffect(function () {
        if (trigger) {
            dispatch(userCreate(bodyRequest));
        }
    }, [trigger]);
    return {
        responseUserCreate: responseUserCreate,
        errorUserCreate: errorUserCreate,
        loadingUserCreate: loadingUserCreate,
    };
};
